var map = {
	"./box": 182,
	"./box/": 182,
	"./box/block": 1198,
	"./box/block.json": 1198,
	"./box/index": 182,
	"./box/index.tsx": 182,
	"./box_children": 8557,
	"./box_children/": 8557,
	"./box_children/block": 6886,
	"./box_children/block.json": 6886,
	"./box_children/image_box": 2686,
	"./box_children/image_box.tsx": 2686,
	"./box_children/index": 8557,
	"./box_children/index.tsx": 8557,
	"./box_children/modal_files_box": 6022,
	"./box_children/modal_files_box.tsx": 6022,
	"./box_children/styles.scss": 4852,
	"./column": 7847,
	"./column/": 7847,
	"./column/block": 166,
	"./column/block.json": 166,
	"./column/index": 7847,
	"./column/index.tsx": 7847,
	"./column/styles.scss": 6877,
	"./columns": 4869,
	"./columns/": 4869,
	"./columns/block": 2603,
	"./columns/block.json": 2603,
	"./columns/index": 4869,
	"./columns/index.tsx": 4869,
	"./embedded": 2409,
	"./embedded/": 2409,
	"./embedded/block": 2663,
	"./embedded/block.json": 2663,
	"./embedded/index": 2409,
	"./embedded/index.scss": 3392,
	"./embedded/index.tsx": 2409,
	"./empty": 8183,
	"./empty/": 8183,
	"./empty/index": 8183,
	"./empty/index.tsx": 8183,
	"./empty/styles.scss": 2436,
	"./heading": 7910,
	"./heading/": 7910,
	"./heading/block": 8220,
	"./heading/block.json": 8220,
	"./heading/index": 7910,
	"./heading/index.tsx": 7910,
	"./image": 1351,
	"./image/": 1351,
	"./image/block": 7153,
	"./image/block.json": 7153,
	"./image/index": 1351,
	"./image/index.tsx": 1351,
	"./image/modal_files": 7302,
	"./image/modal_files.tsx": 7302,
	"./image/styles.scss": 5171,
	"./paragraph": 3844,
	"./paragraph/": 3844,
	"./paragraph/block": 8351,
	"./paragraph/block.json": 8351,
	"./paragraph/index": 3844,
	"./paragraph/index.tsx": 3844,
	"./svg": 7648,
	"./svg/": 7648,
	"./svg/block": 3596,
	"./svg/block.json": 3596,
	"./svg/index": 7648,
	"./svg/index.tsx": 7648,
	"./svg/styles.scss": 2479
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2365;